import React, {Component} from 'react'
import {connect} from 'react-redux'
import {history} from '../../store';
import IgniteDataTable from '../common/datatable'
import {orderAgain, viewInvoice} from '../../actions/orders'
import {getMyProfile} from '../../actions/user';
import {checkPermission} from '../common/guards/can';
import {dateFormat} from '../../utils/commonFunctions';

class OrdersList extends Component {
  constructor(props){
    super(props);

    this.state = {
      delete: {
        show: false
      }
    }
  }

  hasLineItems(row) {
    return row.relationships &&
            row.relationships['line-items'] &&
              row.relationships['line-items']['data'] &&
                row.relationships['line-items']['data'].length > 0;
  }

  render() {
    const columns = [
      {prop: 'order-date', title: 'Order Date', width: '100', format(data, row) {return dateFormat(data)}},
      {prop: 'order-type', title: 'Order Type', width: '110'},
      {prop: 'order-number', title: 'Order Number', width: '150'},
      {prop: 'your-reference', title: 'Reference', width: '100'},
      {prop: 'customer-number', title: 'Customer Number', width: '140'},
      {prop: 'status', title: 'Order Status', width: '130'},
    ];

    const actions = [
      {
        label: 'Order again',
        color: 'yellow',
        permissions: {
          action: 'order',
          subjectClass: 'stock'
        },
        render: (cell, row) => this.hasLineItems(row),
        callback: (row) => {
          this.props.dispatch(orderAgain(row.id))
              .then((response) => {
                this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
                history.push('/order/new');
              });
        }
      },
      {
        label: 'View order',
        render: (cell, row) => this.hasLineItems(row),
        callback: (row) => {
          history.push(`/my-orders/${row.id}`);
        }
      },
      {
        label: 'View invoice',
        color: 'grey',
        disabled: (row) => !row.attributes.invoice || !checkPermission('order', 'stock'),
        callback: (row) => {
          this.props.dispatch(viewInvoice(row.id));
        }
      },
    ];

    return (
      this.props.orders && <IgniteDataTable data={this.props.orders}
                                            dataSize={this.props.pagination.number * this.props.pagination.size}
                                            columns={columns}
                                            actions={actions}
                                            actionWidth="200"
                                            inlineActions={false}
                                            pagination={{
                                              onPageChange: this.props.onPageChange,
                                              page:         this.props.currentPage
                                            }}
                                            remote/>
    )
  }
}

export default connect()(OrdersList)


// WEBPACK FOOTER //
// ./src/components/my-orders/complete-orders-list.jsx